/* eslint-disable no-shadow */
import saga from 'Modules/account-list/store/saga'
import reducer from 'Modules/account-list/store/reducer'
import { useInjectReducer, useInjectSaga } from 'Stores'
import { useDispatch, useSelector } from 'react-redux'
import { makeSelectAccount } from 'Modules/account-list/store/selectors'
import { getAccountList, inviteEmail, postAcceptedInviteMember, changeEmail, changeEmailVerifyToken, deleteAccount } from 'Modules/account-list/store/actions'

export const useAccount = () => {
  useInjectSaga({ key: 'accountList', saga })
  useInjectReducer({ key: 'accountList', reducer })

  const { accountList } = useSelector(
    makeSelectAccount()
  )

  const dispatch = useDispatch()
  const getAccountAction = (payload) => dispatch(getAccountList(payload))
  const inviteEmailAction = (payload) => dispatch(inviteEmail(payload))
  const postAcceptedInviteMemberAction = (payload) => dispatch(postAcceptedInviteMember(payload))
  const changeEmailAction = (payload) => dispatch(changeEmail(payload))
  const changeEmailVerifyTokenAction = (payload) => dispatch(changeEmailVerifyToken(payload))
  const deleteAccountAction = (payload) => dispatch(deleteAccount(payload))

  return {
    accountList,
    getAccountAction,
    inviteEmailAction,
    postAcceptedInviteMemberAction,
    changeEmailAction,
    changeEmailVerifyTokenAction,
    deleteAccountAction
  }
}

export const useDeleteAccount = () => {
  useInjectSaga({ key: 'delete', saga })
  useInjectReducer({ key: 'delete', reducer })

  const { deleteAccount } = useSelector(
    makeSelectAccount()
  )

  return {
    deleteAccount
  }
}
